import { render } from "./Profileinfo.vue?vue&type=template&id=01e76b8a"
import script from "./Profileinfo.vue?vue&type=script&lang=js"
export * from "./Profileinfo.vue?vue&type=script&lang=js"

import "./Profileinfo.vue?vue&type=style&index=0&id=01e76b8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__